<template>
  <!--
    Compact, reusable pagination bar used both above and below large tables.
    The parent owns the `pagination` object ({ page, total, size }); this
    component only renders it and emits `page-change` / `size-change`.
  -->
  <div class="table-pagination">
    <div class="table-pagination__total">
      <span class="text-primary font-weight-bold">{{ pagination.total }}</span>
      <span class="table-pagination__label text-capitalize">{{ counterLabel }}</span>
    </div>

    <b-pagination
        class="table-pagination__nav mb-0"
        :value="pagination.page"
        :total-rows="pagination.total"
        :per-page="pagination.size"
        size="sm"
        align="center"
        first-number
        last-number
        @change="page => $emit('page-change', page)"
    />

    <div class="table-pagination__size">
      <b-select
          size="sm"
          :value="pagination.size"
          class="table-pagination__select"
          @change="size => $emit('size-change', size)"
      >
        <b-select-option v-for="s in sizes" :key="s" :value="s">{{ s }}</b-select-option>
      </b-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    sizes: {
      type: Array,
      default: () => [25, 50, 100, 250, 500],
    },
    counterLabel: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.table-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  border-radius: 10px;
  background: rgba(0, 123, 255, 0.04);
  border: 1px solid rgba(0, 123, 255, 0.10);
}

.table-pagination__total {
  font-size: 0.85rem;
  white-space: nowrap;
}

.table-pagination__label {
  margin-left: 0.25rem;
  color: #6e6b7b;
}

.table-pagination__nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.table-pagination__size {
  display: flex;
  align-items: center;
}

.table-pagination__select {
  width: 80px;
}

// ----- Dark theme -----
.dark-layout .table-pagination {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.08);
}
.dark-layout .table-pagination__label {
  color: #b4b7bd;
}
</style>
